/** Which corner of the viewport a backdrop wheel hangs its hub outside of. */
export enum SpokeWheelCorner {
  TopRight = "topRight",
  BottomLeft = "bottomLeft",
}
